var _path, _path2, _path3, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M.556 85.523H512v340.955H.556z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#a2001d",
  d: "M0 315.298h511.444V85.52H0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M100.065 315.298V85.52H0v340.962h511.444-411.379z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#a2001d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M68.564 243.647l-18.531-33.619 18.531-33.091 18.529 33.091z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.502 243.647l-18.53-33.619 18.53-33.091 18.531 33.091zm37.062 91.417l-18.531-33.618 18.531-33.092 18.529 33.092zm-37.062 0l-18.53-33.618 18.53-33.092 18.531 33.092zm37.062 91.418l-18.531-33.619 18.531-33.092 18.529 33.092zm-37.062 0l-18.53-33.619 18.53-33.092 18.531 33.092zM68.564 152.23l-18.531-33.619 18.531-33.093 18.529 33.093z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.502 152.23l-18.53-33.619 18.53-33.093 18.531 33.093z"
}))));

export default SvgBy;